export default {
  PASSWORD_MIN_LENGTH: 8,
  PASSWORD_MAX_LENGTH: 32,
  PHONE_MIN_LENGTH: 5,
  PHONE_MAX_LENGTH: 16,
  TEXTAREA_MAX_LENGTH: 1500,
  MAX_TITLE_LENGTH: 100,
  MAX_TEXT_LENGTH: 500
}
